import { getPaymentMethods } from "features/paymentMethods/api";
import useFetchPaymentMethods from "./useFetchPaymentMethods";

const useActions = () => ({
    getAllPaymentMethods: useFetchPaymentMethods({
        resourceRequest: getPaymentMethods
    })
});

export default useActions;
